export default "assets/images/logo-light-6f7ba2e6.svg";